module.exports = __webpack_public_path__ + "static/media/shareit-green.8f04091b.svg";